import type { Infer } from 'superstruct';
import {
	dynamic,
	nullable,
	number,
	object,
	optional,
	partial,
	string,
	trimmed,
} from 'superstruct';

import { ViewMediaDto } from '@adflow/shared/data-media';
import {
	optionalPhoneNumber,
	parsableInteger,
	userString,
} from '@adflow/shared/util-superstruct';

export const AddFacebookAdCreativeMediaTemplateDto = object({
	id: optional(parsableInteger()),
	headline: userString('validations:Required'),
	description: userString('validations:Required'),
	urlPath: trimmed(optional(nullable(string()))),
	phoneNumber: dynamic((value, { branch }) => {
		const adSet = branch.at(-8);
		if (adSet?.destinationType === 'PHONE_CALL') {
			return optionalPhoneNumber();
		}
		return trimmed(optional(nullable(string())));
	}),
	mediaFileId: parsableInteger(),
	mediaFile: optional(ViewMediaDto),
});

export const ViewFacebookAdCreativeMediaTemplateDto = object({
	id: number(),
	headline: string(),
	description: string(),
	urlPath: string(),
	phoneNumber: optional(nullable(string())),
	mediaFileId: number(),
	mediaFile: optional(ViewMediaDto),
});
export type ViewFacebookAdCreativeMediaTemplateDto = Infer<
	typeof ViewFacebookAdCreativeMediaTemplateDto
>;

export type AddFacebookAdCreativeMediaTemplateDto = Infer<
	typeof AddFacebookAdCreativeMediaTemplateDto
>;
export const EditFacebookAdCreativeMediaTemplateDto = partial(
	AddFacebookAdCreativeMediaTemplateDto
);
export type EditFacebookAdCreativeMediaTemplateDto = Infer<
	typeof EditFacebookAdCreativeMediaTemplateDto
>;
